import React, { memo, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MODAL_SIZES, WIDTH } from 'shared-modules/constants';
import { Modal, Button, InputText } from '../../../../components';
import styles from './inputConfirmation.module.scss';

const InputConfirmation = ({
  isOpen,
  closeModal,
  title,
  callback,
  bodyText,
  buttonBackText,
  buttonNextText,
  value,
  passValueWithKey,
  isOverlap,
  validateFunction,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const onConfirmClick = useCallback(() => {
    const payload = passValueWithKey ? { [passValueWithKey]: inputValue } : inputValue;
    if (callback) callback(payload);
    closeModal();
  }, [callback, closeModal, inputValue, passValueWithKey]);

  useEffect(() => setInputValue(value), [value]);

  const [error, setError] = useState(null);
  const handleInputChange = useCallback(
    (val) => {
      setInputValue(val);
      if (validateFunction) {
        const validationError = validateFunction(val);
        setError(validationError);
      }
    },
    [validateFunction],
  );
  const isNextDisabled = !!error;

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} title={title} isOverlap={isOverlap} size={MODAL_SIZES.WIDTH_400}>
      <div className={styles.bodyText}>{bodyText}</div>
      <InputText
        inputClassName={styles.inputStyle}
        width={WIDTH.PERCENTAGE_100}
        value={inputValue}
        name={passValueWithKey}
        onChange={handleInputChange}
        errorMessages={error ? [{ inputName: passValueWithKey, errorMessage: error }] : []}
        withErrorTooltip
      />
      <div className={styles.buttonRow}>
        <Button onClick={closeModal} secondary>
          {buttonBackText}
        </Button>
        <Button onClick={onConfirmClick} green disabled={isNextDisabled}>
          {buttonNextText}
        </Button>
      </div>
    </Modal>
  );
};
InputConfirmation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  callback: PropTypes.func,
  bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonBackText: PropTypes.string,
  buttonNextText: PropTypes.string,
  value: PropTypes.string,
  passValueWithKey: PropTypes.string,
  isOverlap: PropTypes.bool,
  validateFunction: PropTypes.func,
};
InputConfirmation.defaultProps = {
  title: '',
  callback: null,
  bodyText: '',
  buttonBackText: '戻る',
  buttonNextText: '変更',
  value: '',
  passValueWithKey: '',
  isOverlap: false,
  validateFunction: null,
};

export default memo(InputConfirmation);
